import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { KMDSetting } from '@app/shared/models/kmdSetting';

// Endpoint root
const APIURL = environment.apiUrl;

@Injectable({
  providedIn: 'root',
})
export class KMDSettingService {
  private http = inject(HttpClient);

  get(): Observable<KMDSetting> {
    return this.http.get<KMDSetting>(`${APIURL}/kmdsettings`).pipe(
      map((data) => {
        return { isKmd: true, ...data };
      }),
    );
  }
}
